import { PromotionBanner } from "@clipboard-health/ui-components";
import { WORKER_REFERRALS_SHARE_LINK_PATH_FULL } from "@src/appV2/Referral/path";
import { useHistory } from "react-router-dom";

interface WorkerReferralBannerProps {
  bonusAmount: number;
  getReferralRequirementMessage: (options?: {
    useThirdPerson?: boolean;
    capitalize?: boolean;
  }) => string;
}

export function WorkerReferralBanner(props: WorkerReferralBannerProps) {
  const history = useHistory();
  const { bonusAmount, getReferralRequirementMessage } = props;

  const handleClick = () => {
    history.push(WORKER_REFERRALS_SHARE_LINK_PATH_FULL);
  };

  return (
    <PromotionBanner
      title={`Earn $${bonusAmount} by referring your friends!`}
      subtitle={`You and your friend can earn $${bonusAmount} each after your friend ${getReferralRequirementMessage(
        { useThirdPerson: true }
      )}`}
      icon="gift-lavender-colored"
      backgroundColor={(theme) => theme.palette.common.white}
      borderColor={(theme) => theme.palette.placement!.openHouse.feature.gradient}
      borderVariant="gradient"
      onClick={handleClick}
    />
  );
}
